// TODO: Need to have a default pattern between eslint from Customer and Service
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum MachineModels {
  NETZSCH = 'NETZSCH',
  CONDUX = 'CONDUX',
  CSM = 'CSM',
  CGS = 'CGS',
  S_JET = 'S_JET',
  CONJET = 'CONJET',
  SECOMY = 'SECOMY',
  CFS = 'CFS',
  TAURUS = 'TAURUS',
  BORA = 'BORA',
  PAMIR = 'PAMIR',
  MASTER_CONCH = 'MASTER_CONCH',
  MASTER_CREAM = 'MASTER_CREAM',
  MASTER_NIBS = 'MASTER_NIBS',
  MASTER_MIX = 'MASTER_MIX',
  PMD = 'PMD',
  DEAERATOR = 'DEAERATOR',
  EPSILON = 'EPSILON',
  MAXSHEAR = 'MAXSHEAR',
  OTHER = 'OTHER'
}

export const MachineModelsTemplate = {
  CONDUX: `
    <p><strong>Model:</strong> </p>
    <p><strong>Material:</strong> </p>
    <p><strong>Power:</strong> </p>
    <p><strong>Rotor Execution:</strong> </p>
    <p><strong>Stator Execution:</strong> </p>
    <p><strong>Revolution:</strong> </p>
    <p><strong>Air Volume:</strong> </p>
  `,
  CSM: `
    <p><strong>Model:</strong> </p>
    <p><strong>Material:</strong> </p>
    <p><strong>Grinding disc power:</strong> </p>
    <p><strong>Classifier power:</strong> </p>
    <p><strong>Classifier rotor model:</strong> </p>
    <p><strong>Grinding disc speed:</strong> </p>
    <p><strong>Classifier speed:</strong> </p>
    <p><strong>Air volume:</strong> </p>
  `,
  CGS: `
    <p><strong>Model:</strong> </p>
    <p><strong>Material:</strong> </p>
    <p><strong>Classifier power:</strong> </p>
    <p><strong>Classifier speed:</strong> </p>
    <p><strong>Classifier rotor model:</strong> </p>
    <p><strong>Number of nozzles:</strong> </p>
    <p><strong>Nozzles diameter:</strong> </p>
    <p><strong>Air volume:</strong> </p>
    <p><strong>Air pressure:</strong> </p>
  `,
  S_JET: `
    <p><strong>Model:</strong> </p>
    <p><strong>Material:</strong> </p>
    <p><strong>Working temperature:</strong> </p>
    <p><strong>Classifier rotor model:</strong> </p>
    <p><strong>Classifier power:</strong> </p>
    <p><strong>Classifier speed:</strong> </p>
    <p><strong>Bearing lubrication temperature:</strong> </p>
    <p><strong>Number of nozzles:</strong> </p>
    <p><strong>Nozzle diameter:</strong> </p>
    <p><strong>Steam volume:</strong> </p>
    <p><strong>Steam pressure:</strong> </p>
  `,
  CONJET: `
    <p><strong>Model:</strong> </p>
    <p><strong>Material:</strong> </p>
    <p><strong>Working temperature:</strong> </p>
    <p><strong>Classifier rotor model:</strong> </p>
    <p><strong>Classifier power:</strong> </p>
    <p><strong>Classifier speed:</strong> </p>
    <p><strong>Bearing lubrication temperature:</strong> </p>
    <p><strong>Number of nozzles:</strong> </p>
    <p><strong>Nozzle diameter:</strong> </p>
    <p><strong>Air volume:</strong> </p>
    <p><strong>Air pressure:</strong> </p>
  `,
  SECOMY: `
    <p><strong>Model:</strong> </p>
    <p><strong>Rotor Type:</strong> </p>
    <p><strong>Number of rotor blades:</strong> </p>
    <p><strong>Number of stationary blades:</strong> </p>
    <p><strong>Power:</strong> </p>
    <p><strong>Speed:</strong> </p>
    <p><strong>Sieve Opening:</strong> </p>
    <p><strong>Air Flow:</strong> </p>
  `,
  CFS: `
    <p><strong>Model:</strong> </p>
    <p><strong>Classifier rotor model:</strong> </p>
    <p><strong>Classifier power:</strong> </p>
    <p><strong>Classifier speed:</strong> </p>
    <p><strong>Air volume:</strong> </p>
    <p><strong>Blower power:</strong> </p>
  `,
  TAURUS: `
    <p><strong>Model:</strong> </p>
    <p><strong>Intern volume:</strong> </p>
    <p><strong>Grinding volume:</strong> </p>
    <p><strong>Power:</strong> </p>
    <p><strong>Speed:</strong> </p>
  `,
  BORA: `
    <p><strong>Model:</strong> </p>
    <p><strong>Classifier power:</strong> </p>
    <p><strong>Classifier speed:</strong> </p>
    <p><strong>Rotor material:</strong> </p>
    <p><strong>Air volume:</strong> </p>
    <p><strong>Blower power:</strong> </p>
  `,
  PAMIR: `
    <p><strong>Model:</strong> </p>
    <p><strong>Intern volume:</strong> </p>
    <p><strong>Grinding volume:</strong> </p>
    <p><strong>Power:</strong> </p>
    <p><strong>Speed:</strong> </p>
  `,
  MASTER_CONCH: `
    <p><strong>Conch model:</strong>&ensp;</p>
    <p><strong>Conch power:</strong>&ensp;</p>
    <p><strong>Conch material:</strong>&ensp;</p>
    <p><strong>Water heating power:</strong>&ensp;</p>
    <p><strong>Air flow rate:</strong>&ensp;</p>
    <p><strong>Discharge pump flow rate:</strong>&ensp;</p>
    <p><strong>Air heating power:</strong>&ensp;</p>
  `,
  MASTER_CREAM: `
    <p><strong>MasterCream Model:</strong>&ensp;</p>
    <p><strong>MasterCream cutting configuration:</strong>&ensp;</p>
    <p><strong>MasterCream tooth size:</strong>&ensp;</p>
    <p><strong>MasterCream cutting tool material:</strong>&ensp;</p>
    <p><strong>MasterCream drive power:</strong>&ensp;</p>
    <p><strong>MasterCream maximum speed:</strong>&ensp;</p>
    <p><strong>Screw conveyor power:</strong>&ensp;</p>
    <p><strong>Maximum screw conveyor speed:</strong>&ensp;</p>
  `,
  MASTER_NIBS: `
    <p><strong>MasterNibs model:</strong>&ensp;</p>
    <p><strong>MasterNibs drive power:</strong>&ensp;</p>
    <p><strong>MasterNibs material:</strong>&ensp;</p>
    <p><strong>Hydraulic unit:</strong>&ensp;</p>
    <p><strong>Exhaust system:</strong>&ensp;</p>
    <p><strong>Screw conveyor power:</strong>&ensp;</p>
  `,
  MASTER_MIX: `
    <p><strong>MasterMix model:</strong>&ensp;</p>
    <p><strong>MasterMix power:</strong>&ensp;</p>
    <p><strong>Disc diameter:</strong>&ensp;</p>
    <p><strong>Disc model:</strong>&ensp;</p>
    <p><strong>Disc speed (m/s):</strong>&ensp;</p>
    <p><strong>Tank volume:</strong>&ensp;</p>
    <p><strong>Hydraulic unit:</strong>&ensp;</p>
    <p><strong>Scraper:</strong>&ensp;</p>
    <p><strong>Scraper power:</strong>&ensp;</p>
    <p><strong>VacuumSystem:</strong>&ensp;</p>
  `,
  PMD: `
    <p><strong>PMD model:</strong>&ensp;</p>
    <p><strong>PMD power:</strong>&ensp;</p>
    <p><strong>Disc diameter:</strong>&ensp;</p>
    <p><strong>Disc model:</strong>&ensp;</p>
    <p><strong>Disc speed (m/s):</strong>&ensp;</p>
    <p><strong>Tank volume:</strong>&ensp;</p>
    <p><strong>Hydraulic unit:</strong>&ensp;</p>
    <p><strong>Scraper:</strong>&ensp;</p>
    <p><strong>Scraper power:</strong>&ensp;</p>
    <p><strong>VacuumSystem:</strong>&ensp;</p>
    <p><strong>Washing system:</strong>&ensp;</p>
    <p><strong>Discharge pump:</strong>&ensp;</p>
    <p><strong>Tank type:</strong>&ensp;</p>
  `,
  DEAERATOR: `
    <p><strong>Deaerator model:</strong>&ensp;</p>
    <p><strong>Deaerator power:</strong>&ensp;</p>
    <p><strong>Deaerator speed:</strong>&ensp;</p>
    <p><strong>Vacuum pump type:</strong>&ensp;</p>
    <p><strong>Vacuum pump power:</strong>&ensp;</p>
    <p><strong>Vacuum pump flow:</strong>&ensp;</p>
    <p><strong>Valves (manual or automatic):</strong>&ensp;</p>
  `,
  EPSILON: `
    <p><strong>Epsilon model:</strong>&ensp;</p>
    <p><strong>Epsilon power:</strong>&ensp;</p>
    <p><strong>Epsilon stator/rotor system:</strong>&ensp;</p>
    <p><strong>Epsilon stator opening:</strong>&ensp;</p>
    <p><strong>Epsilon maximum speed:</strong>&ensp;</p>
    <p><strong>Recirculation pump flow rate:</strong>&ensp;</p>
    <p><strong>Pump flow rate:</strong>&ensp;</p>
    <p><strong>Feeding system model:</strong>&ensp;</p>
  `,
  MAXSHEAR: `
    <p><strong>Maxshear model:</strong>&ensp;</p>
    <p><strong>Maxshear power:</strong>&ensp;</p>
    <p><strong>Maxshear maximum speed:</strong>&ensp;</p>
    <p><strong>Stator opening:</strong>&ensp;</p>
    <p><strong>Feeding pump flow rate:</strong>&ensp;</p>
  `
};

/**
 * Retrieves the machine template HTML string based on the provided machine model.
 *
 * @param {MachineModels} model - The machine model enum value.
 * @returns {string} - The corresponding HTML template from `MachineModelsTemplate`.
 */
export function getMachineTemplate(model: MachineModels): string {
  // Define a mapping from enum values to object keys
  const modelKey = model as keyof typeof MachineModelsTemplate;

  // Return the corresponding template or a default message if not found
  return MachineModelsTemplate[modelKey];
}
